module.exports = __webpack_public_path__ + "img/correct.41c84356.svg";